import { CSSProperties } from "react";
import { Flip, Id, ToastOptions, TypeOptions, toast } from "react-toastify";

const toastOptions = (style?: CSSProperties): ToastOptions => ({
  autoClose: 3000,
  transition: Flip,
  hideProgressBar: true,
  closeOnClick: true,
  closeButton: false,
  position: "top-left",
  style: {
    background: "rgb(252, 232, 35)",
    border: "1px solid rgb(44, 48, 52)",
    color: "rgb(44, 48, 52)",
    borderRadius: "12px",
    maxWidth: "100%",
    width: "fit-content",
    transform: "translate(0px, 0px)",
    padding: "0 1rem",
    ...style,
  },
});

export class ToastService {
  static loading({ text, id }: { text: string; id: Id }) {
    toast.loading(text, { ...toastOptions(), toastId: id });
  }

  static update({
    id,
    text,
    style,
    isError = false,
    icon,
    type,
    isLoading = false,
  }: {
    id: Id;
    text?: string;
    style?: CSSProperties;
    isError?: boolean;
    icon?: JSX.Element;
    type?: TypeOptions;
    isLoading?: boolean;
  }): void {
    toast.update(id, {
      render: `${isError ? "Error:" : ""}${text}`,
      icon,
      isLoading,
      type,
      ...toastOptions(style),
    });
  }

  static simple({
    text,
    id,
    icon,
    isError = false,
    style,
    type,
  }: {
    text: string;
    id?: Id;
    isError?: boolean;
    icon?: JSX.Element;
    style?: CSSProperties;
    type?: TypeOptions;
  }): void {
    toast(`${isError ? "Error:" : ""}${text}`, { type, icon, toastId: id, ...toastOptions(style) });
  }

  static clear(id?: Id) {
    toast.dismiss(id);
  }
}
